/**
 * Onboarding email callables
 *
 * Wraps the `sendOnboardingEmailVerification` callable that sends the email double opt-in from the
 * BNPL data screen.
 */

import { httpsCallable } from 'firebase/functions';
import type {
  SendOnboardingEmailVerificationRequest,
  SendOnboardingEmailVerificationResponse,
} from '@physiofit-digital/physiofit_types';
import { functions } from '../../../firebaseConfig';

/**
 * Sends the email double opt-in for the address persisted on the invitation. The server reads the
 * address from the document and decides whether a mail is due; a technical failure throws.
 *
 * @param {Object} req `SendOnboardingEmailVerificationRequest` payload.
 * @return {Promise<Object>} The callable's outcome, `sent` or `skipped`.
 */
export const sendOnboardingEmailVerification = async (
  req: SendOnboardingEmailVerificationRequest,
): Promise<SendOnboardingEmailVerificationResponse> => {
  const callable = httpsCallable<SendOnboardingEmailVerificationRequest, SendOnboardingEmailVerificationResponse>(
    functions,
    'sendOnboardingEmailVerification',
  );
  const { data } = await callable(req);
  return data;
};
